import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

export interface BasicTableProps {
    serviceInfo: any;
}

const BasicTable =({
    serviceInfo
}: BasicTableProps) =>{
    const { t } = useTranslation("clinic");
    const rows = serviceInfo.srv_Time;

    return (
        <TableContainer component={Paper}>
            <Table style={{ border: '0px', borderColor: 'black', borderStyle: 'revert'}}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.weekdayHeader")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.mon")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.tue")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.wed")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.thu")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.fri")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.sat")}</TableCell>
                        <TableCell style={{ padding: '1px', fontSize: '18px', backgroundColor: '#FCE4EC80', textAlign: 'left'}} align="left">{t("schedule.sun")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {index === 0 ? t("schedule.morning") : index === 1 ? t("schedule.afternoon") : t("schedule.evening")}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[0].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[1].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[2].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[3].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[4].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[5].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                            <TableCell style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left'}} align="left">
                                {row[6].yn === 'Y' ? t("schedule.closed") : '✓'}
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={8} style={{ padding: '1px', paddingTop: '5px', paddingBottom : '5px', fontSize: '18px', textAlign: 'left', backgroundColor: '#FCE4EC80'}}>
                            {serviceInfo.srv_Memo}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BasicTable;